import { render, staticRenderFns } from "./page-tiktok.vue?vue&type=template&id=458990bc&"
import script from "./page-tiktok.vue?vue&type=script&lang=js&"
export * from "./page-tiktok.vue?vue&type=script&lang=js&"
import style0 from "./page-tiktok.vue?vue&type=style&index=0&id=458990bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports